<template>
  <div v-loading="isLoging">
    <el-dialog :title="title" width="60%" top="5rem" :close-on-click-modal="false" :visible.sync="showDialog" :destroy-on-close="true" @close="close()">
      <div style="height: 100%">
        <!--设备列表-->
        <el-table :data="alarmList" border style="width: 100%; font-size: 1.2rem">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="warningContent" label="报警详情" align="center" />
          <el-table-column prop="shipName" label="船名" align="center" />
          <el-table-column prop="cameraName" label="报警位置" align="center" />
          <el-table-column prop="warningVideoPath" label="详情" align="center" width="60">
            <template slot-scope="{ row }">
              <el-link @click="showVideo(row)">查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="warningTime" label="报警时间" width="140" align="center">
            <template slot-scope="{ row }">
              <span>{{ new Date(row.warningTime).format('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="warningState" label="状态" width="100" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.warningState == 0 ? '未处理' : '已处理' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button-group>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="display: flex; justify-content: end; margin: 10px 0px" @size-change="handleSizeChange" @current-change="currentChange" :current-page="currentPage" :page-size="count" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next" :total="total"> </el-pagination>
      </div>
    </el-dialog>
    <el-image-viewer
      :z-index="9999"
      index="9999"
      v-if="dialogVisibleImg"
      :on-close="
        () => {
          this.dialogVisibleImg = false
        }
      "
      :url-list="[dialogImageUrl]"
    />
    <el-dialog :visible.sync="dialogVisibleInfo" width="60%" top="5rem" custom-class="infoDialog" :close-on-click-modal="false" @close="dialogVisibleInfo = false">
      <div slot="title" class="info-header">告警详情</div>
      <div>
        <el-tabs v-model="activeName" stretch>
          <el-tab-pane class="picuteBox" label="告警图片" name="first">
            <div style="width: 578px; height: 360px">
              <el-image @click="showImg(alarmInfo.warningImgPathOne)" style="width: 100%; height: 100%" :src="alarmInfo.warningImgPathOne" fit="cover"></el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane class="picuteBox" label="告警图片" name="second">
            <div style="width: 578px; height: 360px">
              <el-image @click="showImg(alarmInfo.warningImgPathTwo)" style="width: 100%; height: 100%" :src="alarmInfo.warningImgPathTwo" fit="cover"></el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane label="告警视频" name="third">
            <video width="578" height="360" :src="alarmInfo.warningVideoPath" controls="controls"></video>
          </el-tab-pane>
          <el-tab-pane disabled></el-tab-pane>
          <el-tab-pane disabled></el-tab-pane>
          <div class="info-text">
            <div>告警名称：{{ alarmInfo.warningContent }}</div>
            <div>告警级别：{{ (alarmInfo.warningLev == 1 ? '一' : alarmInfo.warningLev == 2 ? '二' : '三') + '级预警' }}</div>
            <div>告警时间：{{ new Date(alarmInfo.warningTime).format('yyyy-MM-dd') }}</div>
            <div>告警船名：{{ alarmInfo.shipName }}</div>
            <div>告警场景：{{ alarmInfo.cameraName }}</div>
            <div>船舶位置：(经度:{{ alarmInfo.longitude }} 纬度:{{ alarmInfo.latitude }})</div>
            <div>船舶状态：{{ alarmInfo.shipState }}</div>
            <div>处理状态：{{ alarmInfo.warningState == 0 ? '未处理' : '已处理' }}</div>
          </div>
        </el-tabs>
        <div class="tab-footer">
          <el-button @click="dialogVisibleInfo = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisibleEditInfo = true">处 理</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleEditInfo" width="600px" top="12rem" @close="dialogVisibleEditInfo = false">
      <div style="display: flex; align-items: center">
        <div style="width: 100px">处理意见：</div>
        <el-input v-model="alarmInfo.disposeContent" type="textarea" style="width: 75%" placeholder="请输入内容"></el-input>
      </div>
      <div style="display: flex; margin-top: 10px; align-items: center">
        <div style="width: 100px">结果反馈：</div>
        <el-input v-model="alarmInfo.resultContent" type="textarea" style="width: 75%" placeholder="请输入内容"></el-input>
      </div>
      <div style="display: flex; margin-top: 10px; align-items: center">
        <div style="width: 100px">是否误报：</div>
        <el-select v-model="alarmInfo.isFalseAlarm" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEditInfo = false">取 消</el-button>
        <el-button type="primary" @click="updateDisposeContent">确 定</el-button>
      </span>
    </el-dialog>
    <!--    <el-dialog :visible.sync="dialogVisibleVideo" width="700px" @close="dialogVisibleVideo=false">
      <video width="640" height="360" :src="videoUrl" controls="controls"></video>
    </el-dialog>-->
  </div>
</template>

<script>
import config from '@/utils/config.js'
import MediaServer from './../service/MediaServer'

export default {
  name: 'alarmTable',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  props: {},
  computed: {},
  created() {},
  data() {
    return {
      title: '预警详情',
      level: 0,
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      alarmList: [],
      mediaServer: new MediaServer(),
      currentPage: 1,
      count: 10,
      total: 10,
      dialogVisibleImg: false,
      dialogImageUrl: '',
      videoUrl: '',
      dialogVisibleVideo: false,
      dialogVisibleInfo: false,
      alarmInfo: {},
      activeName: 'first',
      dialogVisibleEditInfo: false,
      options: [
        {
          value: '0',
          label: '否'
        },
        {
          value: '1',
          label: '是'
        }
      ]
    }
  },
  methods: {
    openDialog: function (level, callback) {
      this.currentPage = 1
      this.count = 10
      this.total = 10
      this.alarmList = []
      this.showDialog = true
      this.listChangeCallback = callback
      this.level = level
      this.getAlarmList(level)
      if (level === 1) {
        this.title = '一级预警'
      } else if (level === 2) {
        this.title = '二级预警'
      } else if (level === 3) {
        this.title = '三级预警'
      } else {
        this.title = '历史报警'
      }
    },
    showImg(path) {
      this.dialogVisibleImg = true
      // this.dialogImageUrl = config.API_ROOT + '/' + path
      this.dialogImageUrl = path
    },
    showVideo(row) {
      this.dialogVisibleInfo = true
      if (row.warningImgPathOne) {
        row.warningImgPathOne = row.warningImgPathOne.replace('http://219.153.12.14:9000', 'https://api.lhmovie.com/alarmImg')
      }
      if (row.warningImgPathTwo) {
        row.warningImgPathTwo = row.warningImgPathTwo.replace('http://219.153.12.14:9000', 'https://api.lhmovie.com/alarmImg')
      }
      if (row.warningVideoPath) {
        row.warningVideoPath = row.warningVideoPath.replace('http://219.153.12.14:9000', 'https://api.lhmovie.com/alarmImg')
      }
      this.alarmInfo = row
      console.log(this.alarmInfo)
      this.editId = row.id
      this.disposeContent = row.disposeContent
      // this.videoUrl = config.API_ROOT + '/' + path
      // this.videoUrl = path
    },
    getAlarmList(level) {
      let that = this
      this.$axios({
        method: 'get',
        url: `/api/warningLog/list`,
        params: {
          warningLev: level,
          page: this.currentPage,
          count: this.count
        }
      })
        .then(function (res) {
          /*res.data.data.list.map(s=>{
          s.warningImgPathOne = config.API_ROOT + '/' + s.warningImgPathOne
          s.warningImgPathTwo = config.API_ROOT + '/' + s.warningImgPathTwo
        })*/
          that.total = res.data.data.total
          that.alarmList = res.data.data.list
          that.loading = false
          if (callback) callback()
        })
        .catch(function (error) {
          console.log(error)
          that.loading = false
        })
    },
    currentChange: function (val) {
      this.currentPage = val
      this.getAlarmList(this.level)
    },
    handleSizeChange: function (val) {
      this.count = val
      this.getAlarmList(this.level)
    },
    close() {
      // if (this.title === '历史报警') {
      this.showDialog = false
      this.dialogLoading = false
      this.$parent.$refs.loadCamaer.showWindow()
      // } else {
      //   var that = this;
      //   that.$axios({
      //     method: 'post',
      //     url:`/api/warningLog/updateWarningState`,
      //     params: {warningLev: this.level, warningState: '1'}
      //   }).then(function (res) {
      //     this.showDialog = false;
      //     this.dialogLoading = false;
      //   }).catch(function (error) {
      //     this.showDialog = false;
      //     this.dialogLoading = false;
      //   });
      // }
    },
    updateDisposeContent(row) {
      let that = this
      this.$axios({ method: 'post', url: `/api/warningLog/updateDisposeContent`, params: { id: this.alarmInfo.id, disposeContent: this.alarmInfo.disposeContent, resultContent: this.alarmInfo.resultContent, isFalseAlarm: this.alarmInfo.isFalseAlarm } }).then(res => {
        if (res.data.code === 200) {
          that.$message.success('提交成功！')
          that.dialogVisibleEditInfo = false
          this.getAlarmList(this.level)
        } else {
          that.$message.error(res.data.msg)
        }
      })
    },
    del(row) {
      let that = this
      this.$confirm('确认删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getdeptListLoading = true
        this.$axios({ method: 'post', url: `/api/warningLog/delete`, params: { id: row.id } }).then(res => {
          if (res.data.code === 200) {
            that.$message.success('删除成功！')
            this.getAlarmList(this.level)
          } else {
            that.$message.error(res.data.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.info-header {
  background: #144578;
  height: 40px;
  color: #fff;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
::v-deep.infoDialog .el-dialog__header {
  padding: 0;
}
::v-deep.infoDialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
::v-deep.infoDialog .el-dialog__headerbtn {
  top: 12px;
  right: 15px;
}
::v-deep.el-tabs__content {
  display: flex;
  margin: 100px 0;
  justify-content: space-around;
}
.info-text {
  display: flex;
  flex-flow: column;
  text-align: justify;
  width: 40%;
  line-height: 2;
  color: black;
  font-size: 1.1rem;
}
.info-text div:not(:first-child) {
  margin-top: 10px;
}
.picuteBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tab-footer {
  display: flex;
  justify-content: end;
}
::v-deep.tab-footer .el-button--primary {
  background: #144578;
  border-color: #144578;
}
::v-deep.tab-footer .el-button {
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/alarmTable.vue